module.exports = __webpack_public_path__ + "img/img_hope04.ef60ceb9.webp";